
















import Vue from "vue";
import Modal from "./Modal.vue";

export default Vue.extend({
  components: { Modal },
  methods: {
    onCloseClick() {
      this.$emit("close");
    }
  },
  computed: {
    mobile(): boolean {
      return /Mobile|Android|BlackBerry/i.test(navigator.userAgent);
    },
    pinchMsg(): string {
      return this.mobile
        ? "Pinch and zoom workspace to fill in those details!"
        : "Double click workspace to zoom in or zoom out!";
    }
  }
});
